import React, { useState, useEffect } from "react";
import { getToken, removeToken } from "../auth/AuthService";
import { useNavigate, useLocation } from "react-router-dom";
import { FaSignOutAlt, FaRegQuestionCircle  } from "react-icons/fa";
import { useLoader } from "../helper/Loader";
import HelpTour from "../Components/HelpTour";

export function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loggedIn, setLoggedIn] = useState(false);
  const [startTour, setStartTour] = useState(false)

  const{setIsLoader} = useLoader

  useEffect(() => {
    const tokenExists = !!getToken();
    setLoggedIn(tokenExists);

    if (location.pathname === "/") {
      setLoggedIn(false);
    } else if (tokenExists) {
      setLoggedIn(true);
    }
  }, [location]);

  const handleLogout = () => {
   setStartTour(false);
    removeToken(() => {
      setLoggedIn(false);
    });
    localStorage.clear("loginData")

    navigate("/");
  };
  const handleredirect = () => {
    navigate("/dashboard");
  };

  const handleStartTour = () =>{
    setStartTour(true);
  }
  const handleStopTour = () =>{
    setStartTour(false)
  }

  return (
    <>
    <div className="header">
      <div className="container-fluid">
        <div className="head-block">
          <div className="logo-image tour-logo">
            <img
              src={require("../images/logo-new.png")}
              onClick={handleredirect}
              alt=""
            />
          </div>
          <div style={{display:"flex", gap: "20px"}} onClick={handleStartTour}>
            { loggedIn && (
           <div className="login-button" style={{display: "flex", alignItems: "center", justifyContent: "center", display:"none"}}>
              <FaRegQuestionCircle style={{fontSize: "20px"}}  />
              Take Tour
            </div>
           ) }

          {loggedIn && (
            <div className="login-button logout" style={{display: "flex", alignItems: "center", justifyContent: "center", borderRadius:"15px"}} onClick={handleLogout}>
              <FaSignOutAlt style={{fontSize: "20px"}}  />
              Log Out
            </div>
          )}
          </div>
        </div>
      </div>
    </div>
    {startTour && (
      <HelpTour start = {startTour} setStartTour = {setStartTour} onStopTour = {handleStopTour}/>
    )}
    </>
  );
}
